import React, { useContext } from "react";
import { Switch, Route, NavLink, } from "react-router-dom";
import { AppStateContext, EloginStatus } from "../../app-state";
import { FullHeader } from "../common/header-and-footer/FullHeader";
import { EventDetail } from "../event-master/detail/EventDetail";
import { PublicEventList } from "../event-master/event-list/Index";
import { HowTo } from "../event-master/articles/HowTo";
import { SiteFooter } from "../common/header-and-footer/SiteFooter";
export const ListingMaster = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    return (React.createElement("div", { className: "event-master" },
        React.createElement(FullHeader, null),
        React.createElement("div", { className: "navbar" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "navbar-inner" },
                    React.createElement("nav", { className: "left-side" },
                        React.createElement(NavLink, { to: "/cs/seznam/nejblizsi-aukce", className: "navbar-item" }, "Nejbli\u017E\u0161\u00ED aukce"),
                        React.createElement(NavLink, { to: "/cs/seznam/probihajici-aukce", className: "navbar-item" }, "Prob\u00EDhaj\u00EDc\u00ED aukce"),
                        React.createElement(NavLink, { to: "/cs/seznam/ukoncene-aukce", className: "navbar-item" }, "Ukon\u010Den\u00E9 aukce"),
                        state.loginState == EloginStatus.Logged && React.createElement(NavLink, { to: "/cs/seznam/moje-aukce", className: "navbar-item" }, "Moje aukce")),
                    React.createElement("nav", { className: "right-side" }, state.user.role == 'admin' ?
                        React.createElement(NavLink, { to: "/cs/sekce/sprava-aukci", className: "navbar-item" }, "Spr\u00E1va aukc\u00ED")
                        :
                            React.createElement(NavLink, { to: "/cs/seznam/podminky-ucasti", className: "navbar-item" }, "Podm\u00EDnky \u00FA\u010Dasti"))))),
        React.createElement("div", { className: "event-master-page" },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/cs/seznam/ukoncene-aukce/detail/:urlEventId" },
                    React.createElement(EventDetail, null)),
                React.createElement(Route, { path: "/cs/seznam/probihajici-aukce/detail/:urlEventId" },
                    React.createElement(EventDetail, null)),
                React.createElement(Route, { path: "/cs/seznam/nejblizsi-aukce/detail/:urlEventId" },
                    React.createElement(EventDetail, null)),
                React.createElement(Route, { path: "/cs/seznam/moje-aukce" },
                    React.createElement(PublicEventList, { stateFilter: 'my', key: "my" })),
                React.createElement(Route, { path: "/cs/seznam/nejblizsi-aukce" },
                    React.createElement(PublicEventList, { stateFilter: 'closest', key: "closest" })),
                React.createElement(Route, { path: "/cs/seznam/probihajici-aukce" },
                    React.createElement(PublicEventList, { stateFilter: 'open', key: "open" })),
                React.createElement(Route, { path: "/cs/seznam/ukoncene-aukce" },
                    React.createElement(PublicEventList, { stateFilter: 'closed', key: "closed" })),
                React.createElement(Route, { path: "/cs/seznam/podminky-ucasti" },
                    React.createElement(HowTo, null)))),
        React.createElement(SiteFooter, null)));
};
